import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { Box } from "@wix/design-system";
import { useFieldAttributes } from "../../services/field-attributes.js";
import { FieldDescriptionWUT } from "../field-description/field-description-wut.js";
import { FieldErrorWUT } from "../field-error/field-error-wut.js";
import { FieldLabelWUT } from "../field-label/field-label-wut.js";
import { Widget } from "../widget/widget.js";
import { SignatureDrawerWUT } from "./signature-drawer/signature-drawer-wut.js";
import styles from "./signature-field-wut.module.scss";
import { SignatureHeaderWUT } from "./signature-header/signature-header-wut.js";
import { SignatureImageWUT } from "./signature-image/signature-image-wut.js";
import { SignatureTextWUT } from "./signature-text/signature-text-wut.js";
import { SignatureView } from "./signature-types.js";
import { SignatureUploadWUT } from "./signature-upload/signature-upload-wut.js";
import { useSignatureField } from "./use-signature-field.js";
const SignatureFieldWUT = (props) => {
  const {
    id,
    required,
    label,
    hideLabel = false,
    target,
    description,
    validation,
    error,
    requiredIndicatorType,
    requiredIndicatorPlacement,
    onBlur,
    onFocus,
    uploadEnabled,
    FieldLayout,
    onChange,
    value,
    readOnly,
    hasError = false,
    errorMessage,
    widgetHtml,
    widgetEnabled,
    ...rest
  } = props;
  const { labelId, inputId, errorId, descriptionId, ariaDescribedBy } = useFieldAttributes(id, error, description);
  const {
    signatureMode,
    clearable,
    signatureValueForView,
    signatureView,
    handleChange,
    setSignatureMode,
    handleBeforeChange,
    handleClear
  } = useSignatureField({ target, value, onChange });
  return /* @__PURE__ */ jsx(
    FieldLayout,
    {
      fieldId: id,
      renderLabel: () => /* @__PURE__ */ jsxs(Box, { direction: "vertical", width: "100%", children: [
        /* @__PURE__ */ jsx(
          FieldLabelWUT,
          {
            labelId,
            htmlFor: inputId,
            required,
            label,
            hideLabel,
            requiredIndicatorType,
            requiredIndicatorPlacement
          }
        ),
        !readOnly && /* @__PURE__ */ jsx(
          SignatureHeaderWUT,
          {
            signatureMode,
            onModeChange: setSignatureMode,
            onClear: handleClear,
            clearable,
            uploadEnabled,
            inputId,
            ariaLabelledBy: labelId,
            target
          }
        )
      ] }),
      renderInput: () => widgetHtml && widgetEnabled ? /* @__PURE__ */ jsx(
        Widget,
        {
          fieldId: id,
          widgetHtml,
          onChange,
          value
        }
      ) : /* @__PURE__ */ jsx("div", { "data-hook": "signature-input", className: styles.signatureField, children: /* @__PURE__ */ jsxs("div", { className: styles.inputContainer, children: [
        signatureView === SignatureView.DRAW && /* @__PURE__ */ jsx(
          SignatureDrawerWUT,
          {
            fieldId: id,
            inputId,
            hasError,
            onChange: handleChange,
            value: signatureValueForView,
            onBlur,
            required,
            readOnly,
            onBeforeChange: handleBeforeChange,
            ariaLabelledBy: labelId,
            ariaDescribedBy,
            ...rest
          }
        ),
        signatureView === SignatureView.TYPE && /* @__PURE__ */ jsx(
          SignatureTextWUT,
          {
            fieldId: id,
            inputId,
            hasError,
            onChange: handleChange,
            value: signatureValueForView,
            onBlur,
            required,
            onBeforeChange: handleBeforeChange,
            readOnly,
            ariaLabel: label,
            ariaDescribedBy
          }
        ),
        signatureView === SignatureView.IMAGE && /* @__PURE__ */ jsx(SignatureImageWUT, { id: inputId, value: signatureValueForView }),
        signatureView === SignatureView.UPLOAD && /* @__PURE__ */ jsx(
          SignatureUploadWUT,
          {
            id: inputId,
            onBlur,
            readOnly,
            required,
            handleChange,
            hasError,
            ariaLabelledBy: labelId,
            ariaDescribedBy
          }
        )
      ] }) }),
      renderDescription: () => /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          FieldErrorWUT,
          {
            id: errorId,
            target,
            hasError,
            errorMessage
          }
        ),
        /* @__PURE__ */ jsx(FieldDescriptionWUT, { description, id: descriptionId })
      ] })
    }
  );
};
export {
  SignatureFieldWUT
};
//# sourceMappingURL=signature-field-wut.js.map
